import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaConstancias from './TablaConstancias';

const Constancias: React.FC = () => (
  <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
    <TablaConstancias />
  </Box>
);

export default Constancias;
